import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import { useFaqContent } from '../../hooks/useFaqContent';
import styles from './FAQ.module.css';

interface FAQProps {
  slug: string;
  accentColor?: string;
}

const FAQ: React.FC<FAQProps> = ({ slug, accentColor }) => {
  const { t } = useTranslation();
  const { faqs, loading } = useFaqContent(slug);

  if (loading || faqs.length === 0) return null;

  return (
    <section className={styles.faqSection}>
      <div className="container">
        <h2 className={styles.faqTitle}>{t('services.faqTitle')}</h2>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <details key={index} className={styles.faqItem}>
              <summary
                className={styles.faqQuestion}
                style={{ '--accent-color': accentColor } as React.CSSProperties}
              >
                {faq.question}
              </summary>
              <div className={styles.faqAnswer}>
                <ReactMarkdown>{faq.answer}</ReactMarkdown>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
